import React from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getUserRoles } from 'reducers/users';
import {
  getSecurityCompanyFeatures,
  getSecurityCompanyServices,
} from '../../reducers/securityCompany';
import {
  canAccessService,
  getServiceByCategory,
  hasFeature,
} from '../../utils/helper/product';

const ProtectedView = ({
  userRoles,
  allowedRoles,
  children,
  alternateView = null,
  services,
  features,
  path,
}) => {
  const found = allowedRoles.some(role => userRoles.includes(role));
  const renderView = condition => (condition ? children : alternateView);

  if (!found) return <div>{alternateView}</div>;
  if (path?.alwaysVisible) {
    return children;
  }
  if (path?.services) {
    const allowableServicesConsolidated = [];
    const subscribedServices = getServiceByCategory({
      services,
    });
    subscribedServices.forEach(service => {
      if (
        path.services?.find(s =>
          service.allowableServices.some(f => f.id === s),
        )
      ) {
        allowableServicesConsolidated.push(...service.allowableServices);
      }
    });
    const s = canAccessService({
      allowableServices: allowableServicesConsolidated,
      subscribedServices: services,
    });
    return renderView(s);
  }
  // Emergency has to be switched on or off based on features and not services
  if (path?.feature) {
    const isPathEnabledByFeature = hasFeature({
      subscribedFeatures: features,
      feature: path?.feature[0],
    });
    return renderView(isPathEnabledByFeature);
  }

  if (path?.roles) {
    const roleExists = path?.roles.some(s => userRoles.includes(s));
    return renderView(roleExists);
  }

  return children;
};

ProtectedView.propTypes = {
  userRoles: PropTypes.array,
  allowedRoles: PropTypes.array,
  children: PropTypes.object,
  alternateView: PropTypes.object,
  services: PropTypes.array,
  features: PropTypes.array,
  path: PropTypes.object,
};

const mapStateToProps = state => ({
  userRoles: getUserRoles(state),
  services: getSecurityCompanyServices(state),
  features: getSecurityCompanyFeatures(state),
});

export default connect(mapStateToProps)(ProtectedView);
